import {SETTINGS_FAQ, SETTINGS_RPIVACY, SETTINGS_RULES,SETTINGS_SUPPORT} from './../Actions/Types'

const initialState={
    faq:null,
    privacy:null,
    rules:null,
    support:null,
}
export default function (state = initialState,action) {
    switch (action.type) {
        case SETTINGS_FAQ:
            return {
                ...state,
                faq: action.payload
            }
        case SETTINGS_RPIVACY:
            return {
                ...state,
                privacy: action.payload
            }
        case SETTINGS_RULES:
            return {
                ...state,
                rules: action.payload
            }
            case SETTINGS_SUPPORT:
            return {
                ...state,
                support: action.payload
            }
            default:
            return state
    }
}